import { IconItem } from '../IconList';
export default IconItem;
//# sourceMappingURL=index.js.map